import * as React from 'react';

import { SimilaritySearch, SimilaritySearchProps } from './similarity-search';

interface SimilaritySearchButtonProps extends Partial<SimilaritySearchProps> {
    renderElement: (onClick: () => void) => React.ReactElement;
}

export const SimilaritySearchButton: React.FC<SimilaritySearchButtonProps> = ({ renderElement, ...searchProps }) => {
    const [isDialogOpen, setIsDialogOpen] = React.useState(false);

    const handleOpenSimilaritySearch = () => {
        setIsDialogOpen(true);
    };

    const handleCloseSimilaritySearch = () => {
        setIsDialogOpen(false);
    };

    return (
        <>
            {renderElement(handleOpenSimilaritySearch)}
            {isDialogOpen && <SimilaritySearch {...searchProps} onClose={handleCloseSimilaritySearch} />}
        </>
    );
};
